import { render, staticRenderFns } from "./Hover6.vue?vue&type=template&id=3990d78c&scoped=true&"
import script from "./Hover6.vue?vue&type=script&lang=js&"
export * from "./Hover6.vue?vue&type=script&lang=js&"
import style0 from "./Hover6.vue?vue&type=style&index=0&id=3990d78c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990d78c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VCard,VRating})
